import ApiService from "@/api/api";

export default class DirbiLeiInformaticaService {
  constructor() {
    this.resource = "/v1/clientes";
  }

  /**
   * Valor do crédito financeiro (Limite de Crédito do Sigplani) dos trimestres
   * selecionados, com a composição por competência.
   * @param {number} clientId
   * @param {{ anoBase: number|string, trimestres: number[] }} params
   */
  getDirbi(clientId, params) {
    return ApiService.get(`${this.resource}/${clientId}/dirbi-lei-informatica`, {
      params
    });
  }

  /**
   * Solicita a exportação assíncrona do PDF (ExportacaoJob → DirbiLeiInformaticaExport).
   * @param {number} clientId
   * @param {{ anoBase: number|string, trimestres: number[], acumulada: boolean, trimestreReferencia: number|null }} data
   */
  exportar(clientId, data) {
    return ApiService.post(`${this.resource}/${clientId}/exportacao`, {
      tipoRelatorio: "dirbi-lei-informatica",
      ...data
    });
  }
}
